export default __webpack_public_path__ + "static/media/interior-2685521_640.64c44421.jpg";